<template>
  <header class="main-header">
    <!-- Logo -->
    <router-link to="/home" class="logo">
<!--      <span class="logo-mini"><b> <img src="/static/img/logo.png" alt="User Image"></b></span>-->
<!--      <span class="logo-lg"><img src="/static/img/logo.png" alt="User Image"><b style="font-size: x-large; padding-right: 8px">东迅</b>工资条</span>-->
      <span class="logo-mini"><b>东迅</b></span>
      <span class="logo-lg" style="text-align: center"><b style="font-size: x-large;">东迅工资条</b></span>
    </router-link>
    <!-- Header Navbar: style can be found in header.less -->

    <nav class="navbar navbar-static-top">
      <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button"> <span
        class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span
        class="icon-bar"></span> </a>
      <!--<Breadcrumb class="hamburger-container" :toggleClick="toggleSideBar" :isActive="opened"></Breadcrumb>-->

      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- Notifications: style can be found in dropdown.less -->
          <li>
            <el-dropdown class="header-dropdown-devin" trigger="click">
              <span class="el-dropdown-link">
                <el-badge :value="this.memoList.filter(m => !m.handled).length" :hidden="this.memoList.length<=0" class="item">
                  <el-button type="text" size="small"><i class="ti-bell"></i></el-button>
                </el-badge>
              </span>
              <el-dropdown-menu slot="dropdown" size="medium">
                <ul class="dropdown-menu-devin">
                  <li>
                    <!-- inner menu: contains the actual data -->
                    <ul class="menu">
                      <template v-for="item in memoList">
                        <li>
                          <i style="margin: 10px 20px 0 0" @click="handleMemoHandledClick(item.id)">
                            <el-switch
                              v-model="item.handled"
                              active-color="#ff4949"
                              inactive-color="#13ce66"
                              @change="handleMemoHandledChange"
                            />
                          </i>
                          <a>
                            <h3 v-bind:class="{handled: item.handled}">
                              <a v-if="item.followId" @click="handleFollowClick(item.customerId, item.followId)" style="text-decoration:underline !important; color: blue !important; cursor: pointer">{{item.remark}}</a>
                              <a v-else>{{item.remark}}</a>
                              <span class="text-yellow fontello-record"></span>
                            </h3>
                            <p v-bind:class="{handled: item.handled}">{{item.memoAtText}}</p>
                          </a>
                        </li>
                      </template>
                    </ul>
                  </li>
                </ul>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>
<script>
  import Breadcrumb from './Breadcrumb'
  import {SystemMemoService} from "../../system-memo-service";

  export default {
    components: {
      Breadcrumb
    },
    name: 'DashboardHeader',
    data: function () {
      return {
        search: '',
        opened: true,
        memoItemId: 0
      }
    },
    computed: {
      memoList: function () {
        let rst = this.$store.state.memoList;
        return rst;
      }
    },
    mounted: function () {
      SystemMemoService.getInstance(this).refresh();
    },
    methods: {
      toggleSideBar: function () {
        this.$store.dispatch('ToggleSideBar')
      },

      /**
       * 备忘状态改变
       */
      handleMemoHandledChange: function (v) {
          this.axios.post('/admin/systemMemo/handledChange', [], {params: {systemMemoItemId: this.memoItemId, handled: v}}).then(resp => {
            if (resp.data && resp.data.code === 200) {
              //  没啥需要响应的
            } else {
              that.$message({
                type: 'error',
                message: "更新备忘列表失败。"
              })
            }
          }).catch(resp => {
            that.$message({
              type: 'error',
              message: "更新备忘列表失败。"
            })
          });
        },

      /**
       * 备忘状态被点击
       * @param event
       */
      handleMemoHandledClick: function (id) {
        this.memoItemId = id;
      },

      /**
       * 处理“跟踪”点击
       * @param customerId
       * @param followId
       */
      handleFollowClick: function (customerId, followId) {
        this.$router.push({
          path: '/customer/customerFollowModify',
          query: {id: followId, customerId: customerId, emp: false}
        })
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .handled {
    text-decoration: line-through;
  }
</style>




// WEBPACK FOOTER //
// Header.vue?1bf29119